import React from 'react';
import { Row, Col, List } from 'antd';
import { Inference as InferenceType } from '../../../types';
import { getAnnotationLabels } from '../../../lib/labels';
import { Icon } from '@ant-design/compatible';
import { Link } from 'react-router-dom';

type Props = {
  inference: InferenceType;
  onItemClickUrl: (trainingId: string) => any;
};
export const Inference = ({ inference, onItemClickUrl }: Props) => {
  const classification = inference && inference.annotations && inference.annotations.type;

  return (
    <List.Item>
      <List.Item.Meta
        title={
          <span>
            <Icon
              type="file-pdf"
              theme="twoTone"
              twoToneColor={inference.status === 'FINISHED' ? '#00b9ff' : '#999'}
              style={{ marginRight: '10px' }}
            />
            {inference.status === 'FINISHED' ? (
              <Link to={onItemClickUrl(inference.trainingId)}>{inference.fileName}</Link>
            ) : (
              <span>{inference.fileName}</span>
            )}
          </span>
        }
      />
      {inference && inference.annotations && inference.annotations.fields && (
        <Row>
          <Col>
            {classification ? (
              <span style={{ color: '#9fa0a7' }}>{classification.name}</span>
            ) : (
              <span style={{ color: '#9fa0a7' }}>
                {getAnnotationLabels(inference, inference.model).length} annotations
              </span>
            )}
          </Col>
        </Row>
      )}
    </List.Item>
  );
};
